export const onDataChanged = <T>(
  id: string | undefined,
  data: T[],
  selectedData: T | null,
  key: keyof T,
  callback: (data: T) => void,
): void => {
  if (id && data?.length > 0 && !selectedData) {
    const foundData = data.find((item) => `${item[key]}` === id);

    if (!foundData) return;

    callback(foundData);
  }
};
